import { dataProps } from './properties'

export const setCustomerTagList = (state, payload) => {
    state.list = payload
}    

export const setCustomerTagData = (state, payload) => {
    state.props = payload
} 

export const resetCustomerTagData = state => {
    state.props = JSON.parse(JSON.stringify(dataProps))
}


// WEBPACK FOOTER //
// ./src/store/modules/customerTag/mutations.js